export * from './forbidden';
export * from './no-content';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/no-content/index.ts